"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var ga_sidecar_1 = require("@engine/ga-sidecar");
var settings_sidecar_1 = require("@engine/settings-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var crokinoleGamepadCursors_sidecar_1 = require("@crokinole/cursors/crokinoleGamepadCursors-sidecar");
var crokinoleKeyboard_sidecar_1 = require("@crokinole/input/crokinoleKeyboard-sidecar");
var crokinoleDefs_sidecar_1 = require("@crokinole/main/crokinoleDefs-sidecar");
var crokinoleGameManager_sidecar_1 = require("@crokinole/main/crokinoleGameManager-sidecar");
var crokinoleTestParams_sidecar_1 = require("@crokinole/main/crokinoleTestParams-sidecar");
var crokinoleWebsockets_sidecar_1 = require("@crokinole/multi/crokinoleWebsockets-sidecar");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var voyageMessages_sidecar_1 = require("@voyage/multi/voyageMessages-sidecar");
var crokinoleSounds_sidecar_1 = require("proto/crokinole/sound/crokinoleSounds-sidecar");
var crokinoleLayers_sidecar_1 = require("./crokinoleLayers-sidecar");
function create() {
    ga_sidecar_1.ga.init('voyage');
    perf2_sidecar_1.perf2.setEnabled(diveDebug_sidecar_1.diveDebug.debug_perf2Enabled);
    spritesUtil_sidecar_1.spritesUtil.setDefaultScale(2);
    settings_sidecar_1.settings.create('voyage:settings', 1);
    crokinoleTestParams_sidecar_1.crokinoleTestParams.loadTestMode();
    voyageMessages_sidecar_1.voyageMessages.registerAll();
    var soundsJson = common_sidecar_1.common.getPhaserScene().cache.json.get('audioSprite2');
    // voyageSounds.load(soundsJson, '/assets/music')
    crokinoleSounds_sidecar_1.crokinoleSounds.load(soundsJson, '/assets/music');
    // voyageLayers.create()
    crokinoleLayers_sidecar_1.crokinoleLayers.create();
    rogueGlyphs_sidecar_1.rogueGlyphs.setDefaultLayer(crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().ui1);
    uiFps_sidecar_1.uiFps.create(crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().uiGame);
    uiFps_sidecar_1.uiFps.setOpen(true);
    clickEater_sidecar_1.clickEater.create();
    crokinoleKeyboard_sidecar_1.crokinoleKeyboard.create();
    crokinoleWebsockets_sidecar_1.crokinoleWebsockets.create();
    crokinoleGameManager_sidecar_1.crokinoleGameManager.goLoading();
    crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.createAll();
    if (crokinoleDefs_sidecar_1.crokinoleDefs.proto_showGeoscape) {
    }
}
exports.create = create;
